<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781466817081_toc01#toctitle2" id="title2"><span><strong class="b">PART I</strong></span></a></div>
<div class="illustype_image"><div class="caption"><div class="p-br"><span><em class="i">Boy with Head on Mother’s Lap,</em> one of a group of pen-and-ink drawings based<br/>on memories from Gorky’s childhood, c. 1938–39</span></div></div>
<div class="image"><img alt="e9781466817081_i0003.jpg" src="e9781466817081_i0003.jpg"/></div>
<a id="page_8"></a></div><a id="page_8">
</a><a id="page_9">
</a></div><a id="page_9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466817081_p01.vue?0bc35d4c